import i18n from 'i18next';

/**
 * Returns the display name from a translations dict using the current i18n language.
 * Falls back: current lang → "en" → "ar" → empty string.
 */
export function tn(translations: Record<string, string> | null | undefined): string {
  if (!translations) return '';
  const lang = i18n.language || 'en';
  return translations[lang] || translations['en'] || translations['ar'] || '';
}

